const search = {};
search.rules = {};
search.hookClick = function() {
  $('[data-tag]').on('click', function(event) {
    $('.js-search-text')[0].value = '';
    const e = event.target;
    search.apply(e);
    search.transition();
  });

  $('.js-search-cancel').on('click', function(event) {
    $('.js-search-text')[0].value = '';
    $('.js-category .is-current').each(function(i, e) {
      e.classList.remove('is-current');
    });
    search.rules = {};
    search.transition();
    search.enableAll();
  });
};
search.parse = function() {
  $('[data-tag]').each(function(i, e) {
    const name = e.textContent.slice(1);
    if (decodeURI(location.search).match(RegExp(name))) {
      search.apply(e);
    }
  });
};
search.compose = function() {
  const q = [];
  Object.keys(search.rules).forEach(function(k) {
    q.push('(' + search.rules[k].join(' OR ') + ')');
  });

  return q.join(' OR ');
};
search.apply = function(e) {
  const tag = e.dataset.tag;
  const name = e.textContent.slice(1);
  if (search.rules[tag] && search.rules[tag].indexOf('tag:' + name) !== -1) {
    search.removeTag(tag, name);
    e.classList.remove('is-current');
  } else {
    if (tag !== 'キーワード') {
      search.rules[tag] = [];
      $('[data-tag="' + tag + '"]').each(function(i, x) {
        x.classList.remove('is-current');
      });
    }
    search.pushTag(tag, name);
    e.classList.add('is-current');
  }

  search.enableAll();
};
search.transition = function() {
  $(window).trigger('loadSearchShow');

  const url = '/search?q=' + search.compose();
  $.get(url).done(function(e) {
    $('.js-search')[0].innerHTML = $('.js-search', e)[0].innerHTML;
    $('.js-search-count')[0].innerHTML = $('.js-search-count', e)[0].innerHTML;

    document.title = $('.js-title', e)[0].textContent;
    history.pushState(null, null, url);
    product.hookCartBtn();

    $(window).trigger('loadSearchHide');
  });
};
search.pushTag = function(tag, name) {
  if (!search.rules[tag]) {
    search.rules[tag] = [];
  }
  search.rules[tag].push('tag:' + name);
};
search.removeTag = function(tag, name) {
  if (search.rules[tag].length < 2) {
    delete search.rules[tag];
    return;
  }

  const index = search.rules[tag].indexOf('tag:' + name);
  search.rules[tag] = search.rules[tag].splice(index - 1, 1);
};
search.enableTag = function() {
  $('.js-search-tag')[0].classList.remove('-is-disable');
  $('.js-search-keyword')[0].classList.add('-is-disable');
};
search.enableKeyword = function() {
  $('.js-search-tag')[0].classList.add('-is-disable');
  $('.js-search-keyword')[0].classList.remove('-is-disable');
};
search.enableAll = function() {
  $('.js-search-tag')[0].classList.remove('-is-disable');
  $('.js-search-keyword')[0].classList.remove('-is-disable');
};
search.disableAll = function() {
  $('.js-search-tag')[0].classList.add('-is-disable');
  $('.js-search-keyword')[0].classList.add('-is-disable');
};
search.hookInput = function() {
  if ($('.js-search-text').length && $('.js-search-text')[0].value !== '') {
    search.disableAll();
  }

  $('.js-search-text').on('keyup', function(event) {
    if (event.target.value !== '') {
      search.disableAll();
    } else {
      search.enableAll();
    }

    if (event.keyCode === 13) {
      event.preventDefault();
      location.href = '/search?q=' + event.target.value;
    }
  });
};
search.init = function() {
  search.parse();
  search.hookClick();
  search.hookInput();
};

(function() {
  search.init();
})();
